import React, { useState } from 'react';
import './QuickActions.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCirclePlus, faClock, faFileLines } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import InvoiceWizard from '../../Invoice/Components/InvoiceWizard/InvoiceWizard';

const QuickActions: React.FC = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [showCreateInvoice, setShowCreateInvoice] = useState(false);

  const handleAddExpense = (): void => {
    navigate('/financial/expenses');
  };

  const handleLogFee = (): void => {
    navigate('/financial/billing');
  };

  const handleCreateInvoice = (): void => {
    setShowCreateInvoice(true);
  };

  const handleInvoiceWizardClose = (): void => {
    setShowCreateInvoice(false);
    queryClient.invalidateQueries({ queryKey: ['invoices'] });
  };

  return (
    <div className="general-quick-actions">
      <h2 className="general-quick-actions-title">Quick Actions</h2>
      <div className="general-quick-actions-grid">
        <div className="general-quick-action-item" onClick={handleAddExpense}>
          <div className="general-quick-action-icon">
            <FontAwesomeIcon icon={faFileCirclePlus} className="general-quick-action-fa-icon" />
          </div>
          <span className="general-quick-action-text">Add Expense</span>
          <span className="general-quick-action-subtitle">Record new expense</span>
        </div>
        
        <div className="general-quick-action-item" onClick={handleLogFee}>
          <div className="general-quick-action-icon">
            <FontAwesomeIcon icon={faClock} className="general-quick-action-fa-icon" />
          </div>
          <span className="general-quick-action-text">Log Fee</span>
          <span className="general-quick-action-subtitle">Track billable time</span>
        </div>
        
        <div className="general-quick-action-item" onClick={handleCreateInvoice}>
          <div className="general-quick-action-icon">
            <FontAwesomeIcon icon={faFileLines} className="general-quick-action-fa-icon" />
          </div>
          <span className="general-quick-action-text">Create Invoice</span>
          <span className="general-quick-action-subtitle">Generate new invoice</span>
        </div>
      </div>

      {showCreateInvoice && (
        <InvoiceWizard
          existingInvoice={undefined}
          onClose={handleInvoiceWizardClose}
        />
      )}
    </div>
  );
};

export default QuickActions;

